<div class="wrap-custom-slider">
    <div *ngIf="floorAllowed - floorShown > 0" class="red-line red-line_left" [style.width]="floorNotAllowedWidth + 'px'">
        <span>{{ floorShown }}</span>
    </div>
    <div *ngIf="ceilShown - ceilAllowed  > 0" class="red-line red-line_right" [style.width]="ceilNotAllowedWidth + 'px'">
        <span>{{ ceilShown }}</span>
    </div>
    <div class="custom-slider" [style.width]="allowedWidth + 'px'">
        <ngx-slider [(value)]="minValue" [(highValue)]="maxValue"
                    [options]="options" (valueChange)="minValueChanged($event)"
                        (highValueChange)="maxValueChanged($event)"></ngx-slider>
    </div>
</div>